"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = RiskAndComplianceScreen;
const jsx_runtime_1 = require("react/jsx-runtime");
const cancelable_promise_1 = require("cancelable-promise");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const Risk_1 = __importDefault(require("../api/Risk"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("../components/Button"));
const react_native_paper_1 = require("react-native-paper");
const Helper_1 = require("../Helper");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Loading_1 = __importDefault(require("../components/Loading"));
const Files_1 = require("../shared/Files");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        button: {
            borderColor: 'transparent',
            alignItems: 'center',
            borderWidth: 1,
            borderRadius: 4,
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 6,
            paddingTop: 9,
            paddingBottom: 7,
            marginTop: 8
        },
        buttonText: {
            color: THEME.White,
            fontSize: 16,
            fontWeight: '600'
        },
        rowButtonIcon: {
            marginRight: 6,
            marginBottom: 1
        }
    });
};
function RiskAndComplianceScreen(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState("");
    const [years, setYears] = react_1.default.useState([]);
    const [locations, setLocations] = react_1.default.useState([]);
    const [selectedLocation, setSelectedLocation] = react_1.default.useState(null);
    const [selectedYear, setSelectedYear] = react_1.default.useState(null);
    const [buttonsDisabled, setButtonsDisabled] = react_1.default.useState(false);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus("loading");
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => {
            Risk_1.default.getLocations(token).then((data) => {
                setYears(data.oshaYears);
                setLocations(data.locations);
                setStatus("done");
            });
        }).catch((e) => {
            setStatus("error");
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    const showSnackbar = (success, message) => {
        react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: success ? "success" : "error", message: message });
    };
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingVertical: 8, paddingHorizontal: 12 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", justifyContent: "center", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.FileLines, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { color: THEME.Text, fontWeight: "500", fontSize: size != 'sm' ? 18 : 16, marginLeft: 12 }, children: t('riskAndCompliance:titles.osha300Log') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: () => props.navigation.goBack(), children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }) }), status != "done" &&
                (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })
                ||
                    (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { keyboardShouldPersistTaps: 'handled', contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, children: (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row' }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: years?.map((year) => ({ label: year, value: year })), label: t('riskAndCompliance:labels.years'), setValue: (value) => setSelectedYear(value), value: selectedYear }) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { list: locations.map((location) => ({ label: location.name, value: location.prismLocationId })), label: t('riskAndCompliance:labels.locations'), setValue: (value) => setSelectedLocation(value), value: selectedLocation }) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", marginTop: 6, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(DownloadButton, { icon: Theme_1.ICONS.Regular.FileContract, isEnabled: !!selectedLocation && !!selectedYear && !buttonsDisabled, location: selectedLocation, year: selectedYear, text: Helper_1.Helper.isPlatformWeb ? t('riskAndCompliance:buttons.downloadOsha') : t('common:buttons.save'), onLoading: () => setButtonsDisabled(true), onError: () => {
                                                    setButtonsDisabled(false);
                                                    showSnackbar(false, t('riskAndCompliance:messages.downloadOhsaFailed'));
                                                    props.navigation.navigate("Company");
                                                }, onDone: async (url) => {
                                                    var locationName = locations.find((location) => location.prismLocationId == selectedLocation)?.name;
                                                    let name = `${selectedYear}_${locationName}_OHSA_Logs.pdf`;
                                                    await Files_1.Files.SaveToDownloads(name, 'application/pdf', url);
                                                    setButtonsDisabled(false);
                                                    showSnackbar(true, t('riskAndCompliance:messages.downloadOhsaSuccess'));
                                                    props.navigation.navigate("Company");
                                                } }) }), !Helper_1.Helper.isPlatformWeb &&
                                            (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(DownloadButton, { icon: Theme_1.ICONS.Regular.BookOpen, isEnabled: !!selectedLocation && !!selectedYear && !buttonsDisabled, location: selectedLocation, year: selectedYear, text: t('common:buttons.view'), onLoading: () => setButtonsDisabled(true), onError: () => {
                                                        setButtonsDisabled(false);
                                                        showSnackbar(false, t('riskAndCompliance:messages.downloadOhsaFailed'));
                                                        props.navigation.navigate("Company");
                                                    }, onDone: (url) => {
                                                        props.navigation.navigate('PdfScreen', { uri: url, title: 'OSHA Logs' });
                                                        setButtonsDisabled(false);
                                                        if (Helper_1.Helper.isPlatformWeb) {
                                                            props.navigation.navigate("Company");
                                                        }
                                                    } }) })] })] }) })] }));
}
const DownloadButton = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [loading, setLoading] = react_1.default.useState(false);
    const load = react_1.default.useCallback(async () => {
        FirebaseAnalytics_1.default.LogEvent('feature_used', {
            'feature': 'Download OSHA Logs',
            'client': userContext.client?.id,
            'employee': userContext.employee?.employeeId
        });
        promise.current?.cancel();
        setLoading(true);
        if (props.onLoading) {
            props.onLoading();
        }
        const token = await userContext.getToken();
        promise.current = (0, cancelable_promise_1.cancelable)(Risk_1.default.getOshaLogs(token, props.location, props.year).then((data) => {
            if (data == null) {
                if (props.onError) {
                    props.onError();
                }
                setLoading(false);
                return;
            }
            let attempts = 0;
            const intervalId = setInterval(() => {
                if (attempts > 10) {
                    if (props.onError) {
                        props.onError();
                    }
                    setLoading(false);
                    clearInterval(intervalId);
                }
                attempts++;
                Risk_1.default.checkLogStatus(token, data.logId).then((logStatusData) => {
                    if (logStatusData.status == 'Available') {
                        if (props.onDone) {
                            props.onDone(data.secureUrl);
                        }
                        setLoading(false);
                        clearInterval(intervalId);
                    }
                }).catch(() => {
                    if (props.onError) {
                        props.onError();
                    }
                    setLoading(false);
                    clearInterval(intervalId);
                });
            }, 3000);
        }).catch(() => {
            if (props.onError) {
                props.onError();
            }
            setLoading(false);
        }));
    }, [props.location, props.year]);
    react_1.default.useEffect(() => {
        setLoading(false);
        return () => promise.current?.cancel();
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { disabled: loading || !props.isEnabled, onPress: () => load(), style: ({ pressed }) => [
            styles.button,
            pressed ? { opacity: 0.6 } : null,
            (loading || !props.isEnabled) ? { backgroundColor: THEME.SolidButtonDisabled } : { backgroundColor: THEME.Primary }
        ], children: loading &&
            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.TextDisabled, size: "small", style: { marginRight: 8 } }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: [styles.buttonText, { color: THEME.TextDisabled }], children: t('common:buttons.loading') })] })
            ||
                (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: size != 'sm' ? 18 : 16, color: !props.isEnabled ? THEME.TextDisabled : THEME.White, style: styles.rowButtonIcon }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: [styles.buttonText, { color: !props.isEnabled ? THEME.TextDisabled : THEME.White }], children: props.text })] }) }));
};
